
import NoteRedactorInput from './NoteRedactorInput.vue';

export default {
  name: 'notesOverlay',
  props: {
    context: {
      type: String,
      required: false,
    },
    contextUuid: {
      type: String,
      required: false,
    },
    path: {
      type: String,
    },
    isWorking: {
      type: Boolean,
    },
  },

  data: () => {
    return {
      viewing: true,
      editing: {},
    };
  },

  mounted() {
    this.$nuxt.$on('editNote', this.editNote);
  },

  beforeDestroy() {
    this.$nuxt.$off('editNote');
  },

  methods: {
    open() {
      this.viewing = true;
    },

    editNote(note) {
      this.editing = { ...note };
      this.viewing = false;
    },

    cancelEditing() {
      this.viewing = true;
    },
    updateNote() {
      this.$emit('update-note', this.editing);
      this.viewing = true;
    },
  },
};
